// @ts-check
import React from 'react';
import {
  widgetDefaultProps,
  widgetPropType,
} from '@glowforge/gf-styled/src/models/widget';

import ExploreMaterials from './explore-materials';
import ExploreMaterialsSecondary from './explore-materials-secondary';

const ExploreMaterialsWidget = ({ layout, materials, attributes }) =>
  layout === 'primary' ? (
    <ExploreMaterials materials={materials} isBuilder attributes={attributes} />
  ) : (
    <ExploreMaterialsSecondary
      materials={materials}
      isBuilder
      attributes={attributes}
    />
  );

ExploreMaterialsWidget.propTypes = { ...widgetPropType };

ExploreMaterialsWidget.defaultProps = { ...widgetDefaultProps };

export default ExploreMaterialsWidget;
